import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { CircleIcon, PolygonIcon, RectangleIcon, TriangleIcon } from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { useTranslation, type MessageKey } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
import type { EditorTool } from '../../../types/editor';

const TOOLS: { id: EditorTool; titleKey: MessageKey; icon: Icon }[] = [
  { id: 'rectangle', titleKey: 'toolbar.tools.rectangle', icon: RectangleIcon },
  { id: 'circle', titleKey: 'toolbar.tools.circle', icon: CircleIcon },
  { id: 'triangle', titleKey: 'toolbar.tools.triangle', icon: TriangleIcon },
  { id: 'polygon', titleKey: 'toolbar.tools.polygon', icon: PolygonIcon },
];

export function ShapeTools() {
  const { t } = useTranslation();
  const { currentTool, setTool } = useEditorStore();
  const activeTool = TOOLS.find((tool) => tool.id === currentTool);
  const isShapeActive = TOOLS.some((tool) => tool.id === currentTool);
  const TriggerIcon = activeTool?.icon ?? RectangleIcon;

  return (
    <div className="shape-tools">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button
            variant="soft"
            radius="none"
            size="3"
            className={`shape-tools-trigger ${isShapeActive ? 'active' : ''}`}
            aria-label={t('toolbar.shapes')}
          >
            <TriggerIcon aria-hidden="true" weight={isShapeActive ? 'fill' : 'regular'} />
            <CaretDownIcon aria-hidden="true" className="shape-tools-chevron" />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content variant="soft" size="2" align="start" sideOffset={4}>
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            const isActive = currentTool === tool.id;
            return (
              <DropdownMenu.Item
                key={tool.id}
                onSelect={() => setTool(tool.id)}
                className={isActive ? 'shape-tools-item-active' : undefined}
              >
                <Icon aria-hidden="true" weight={isActive ? 'fill' : 'regular'} />
                {t(tool.titleKey)}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
